var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { InputDate } from '..';
import moment from 'moment';
import { useEffect, useState } from 'react';
import FlipMove from 'react-flip-move';
import { uid } from './helpers';
import { AddGroupButtonStyled, RemoveButtonContainer, RemoveGroupButton, RemoveGroupIcon, ShipmentHeaderStyled, ShipmentItemStyled, ShipmentItemWarningStyled, ShipmentScheduleGroupStyle, ShipmentScheduleItemListStyled, ShipmentScheduleListStyled, } from './styledComponents';
import dayjs from 'dayjs';
export var ShipmentScheduler = function (_a) {
    var shipmentMapping = _a.shipmentMapping, quoteMapping = _a.quoteMapping, handleChange = _a.handleChange, _b = _a.buttonText, buttonText = _b === void 0 ? 'add' : _b, buttonIcon = _a.buttonIcon, _c = _a.buttonColor, buttonColor = _c === void 0 ? 'primary' : _c, removeShipmentIcon = _a.removeShipmentIcon, _d = _a.onlyFutureShipDateSelection, onlyFutureShipDateSelection = _d === void 0 ? false : _d;
    var _e = useState(null), shipmentSchedule = _e[0], setShipmentSchedule = _e[1];
    useEffect(function () {
        setShipmentSchedule(loadShippingSchedule());
    }, []);
    useEffect(function () {
        if (shipmentSchedule !== null) {
            var parsedMappings = shipmentSchedule.mapping.map(function (group) {
                var lines = group.lines.map(function (item) {
                    return __assign(__assign({}, item), { quantity: typeof item.quantity === 'string' ? parseInt(item.quantity) : item.quantity });
                });
                return { lines: lines, shipDate: moment(group.shipDate).format('YYYY-MM-DD') };
            });
            handleChange && handleChange(parsedMappings);
        }
    }, [shipmentSchedule]);
    //Reads shipmentMapping and quoteMapping props and loads state
    function loadShippingSchedule() {
        //collect cumulative quantity for all items across groups in shipment schedule
        var quantities = shipmentMapping.reduce(function (total, group) {
            return group.lines.reduce(function (lineTotal, item) {
                var _a;
                return __assign(__assign({}, lineTotal), (_a = {}, _a[item === null || item === void 0 ? void 0 : item.partNumber] = (lineTotal[item.partNumber] || 0) + item.quantity, _a));
            }, total);
        }, {});
        //copies item line from first group
        var quoteMappingTotal = Array.isArray(quoteMapping) && quoteMapping.length
            ? quoteMapping[0].lines.reduce(function (total, line) {
                var _a;
                return __assign(__assign({}, total), (_a = {}, _a[line.partNumber] = line.total, _a));
            }, {})
            : {};
        //if quote mapping and shipment mapping differ, make adjustements to match quote mapping
        var itemTotals = shipmentMapping[0].lines.map(function (item) {
            var modified = Boolean(quoteMappingTotal[item.partNumber] && quoteMappingTotal[item.partNumber] !== item.total);
            return __assign(__assign({}, item), { quantity: quantities[item.partNumber], modified: modified, total: modified ? quoteMappingTotal[item.partNumber] : item.total });
        });
        //copies shipment schedule passed to component, assigns each group an ID, and matches data to quote data
        var newShipmentMapping = shipmentMapping.map(function (shipmentMappingGroup) {
            var newLines = shipmentMappingGroup.lines.map(function (item) {
                var itemTotalData = itemTotals.find(function (itemTotal) { return itemTotal.partNumber === item.partNumber; });
                return __assign(__assign({}, item), { total: (itemTotalData === null || itemTotalData === void 0 ? void 0 : itemTotalData.total) || 0 });
            });
            return {
                lines: newLines,
                id: uid(),
                shipDate: moment(shipmentMappingGroup.shipDate).format('YYYY-MM-DD'),
            };
        });
        return {
            mapping: newShipmentMapping,
            itemTotals: itemTotals,
        };
    }
    function createNewShipmentGroup() {
        //create copy of first shipment group in the mapping
        var newShipmentGroup = {};
        if (!shipmentSchedule)
            return;
        //new group ID
        newShipmentGroup.id = uid();
        //set new group's line item quantities to 0
        newShipmentGroup.lines = shipmentSchedule.mapping[0].lines.map(function (lineItem) {
            return __assign(__assign({}, lineItem), { quantity: 0 });
        });
        //ship date based on previous groups ship date
        newShipmentGroup.shipDate = moment(shipmentSchedule.mapping[shipmentSchedule.mapping.length - 1].shipDate)
            .add(1, 'd')
            .format('YYYY-MM-DD');
        setShipmentSchedule(__assign(__assign({}, shipmentSchedule), { mapping: __spreadArray(__spreadArray([], shipmentSchedule.mapping, true), [newShipmentGroup], false) }));
    }
    function removeShipmentGroup(groupID) {
        if (!shipmentSchedule)
            return;
        var itemTotals = shipmentSchedule.itemTotals;
        var newShipmentSchedule = shipmentSchedule.mapping.filter(function (shipmentGroup) { return shipmentGroup.id !== groupID; });
        var group = shipmentSchedule.mapping.find(function (shipmentGroup) { return shipmentGroup.id === groupID; });
        var newItemTotals = itemTotals.map(function (item) {
            var quantity = item.quantity;
            var lineiItem = group && group.lines.find(function (lineItem) { return lineItem.partNumber === item.partNumber; });
            quantity -= lineiItem ? lineiItem.quantity : 0;
            return __assign(__assign({}, item), { quantity: quantity });
        });
        setShipmentSchedule({
            itemTotals: newItemTotals,
            mapping: newShipmentSchedule,
        });
    }
    function updateGroupShipmentDate(groupID, date) {
        if (!shipmentSchedule)
            return;
        //update mapping
        var newShipmentSchedule = shipmentSchedule.mapping.map(function (shipmentGroup) {
            var lines = shipmentGroup.lines.map(function (item) {
                return __assign({}, item);
            });
            return __assign(__assign({}, shipmentGroup), { lines: lines, shipDate: shipmentGroup.id === groupID ? date : shipmentGroup.shipDate });
        });
        var mapping = sortMapping(newShipmentSchedule);
        setShipmentSchedule({
            mapping: mapping,
            itemTotals: shipmentSchedule.itemTotals,
        });
    }
    function updateGroupQuantities(groupID, partNumber, quantity) {
        var itemQuantityDifference = 0;
        if (!shipmentSchedule)
            return;
        //change quantity in new shipment schedule
        var newShipmentSchedule = shipmentSchedule.mapping.map(function (scheduleGroup) {
            if (scheduleGroup.id === groupID) {
                //calculates change from old quantity to new quantity
                var newLines = scheduleGroup.lines.map(function (lineItem) {
                    if (lineItem.partNumber === partNumber) {
                        itemQuantityDifference = quantity - lineItem.quantity;
                        return __assign(__assign({}, lineItem), { quantity: quantity });
                    }
                    return lineItem;
                });
                return __assign(__assign({}, scheduleGroup), { lines: newLines });
            }
            return scheduleGroup;
        });
        var newItemTotals = shipmentSchedule.itemTotals.map(function (item) {
            if (item.partNumber !== partNumber)
                return __assign({}, item);
            var quantity = item.quantity;
            //update change in quantity to cumulative itemTotals state
            quantity += itemQuantityDifference;
            return __assign(__assign({}, item), { quantity: quantity });
        });
        setShipmentSchedule(__assign(__assign({}, shipmentSchedule), { mapping: newShipmentSchedule, itemTotals: newItemTotals }));
    }
    function sortMapping(mapping) {
        //if change in mapping order, update sorted state to true
        //let sorted state tell animation component to run animation
        var sortedMapping = mapping.map(function (group) { return group; });
        sortedMapping.sort(function (a, b) {
            return moment(a.shipDate).diff(moment(b.shipDate));
        });
        return sortedMapping;
    }
    return (<ShipmentScheduleListStyled data-testid="shipment-scheduler">
      <FlipMove>
        {shipmentSchedule &&
            shipmentSchedule.mapping.map(function (data) {
                return (<div key={data.id}>
                <ShipmentScheduleGroup removeGroup={removeShipmentGroup} groupData={data} updateGroupQuantity={updateGroupQuantities} shipDates={shipmentSchedule.mapping.map(function (shipmentGroup) {
                        return shipmentGroup.shipDate;
                    })} updateGroupShipmentDate={updateGroupShipmentDate} itemTotals={shipmentSchedule.itemTotals} oneGroup={shipmentSchedule.mapping.length === 1} onlyFutureShipDateSelection={onlyFutureShipDateSelection} removeShipmentIcon={removeShipmentIcon}></ShipmentScheduleGroup>
              </div>);
            })}
      </FlipMove>
      {shipmentSchedule && (<div style={{ width: 'fit-content' }} data-testid="add-shipment-btn" onClick={createNewShipmentGroup}>
          <AddGroupButton buttonText={buttonText} buttonColor={buttonColor} buttonIcon={buttonIcon}></AddGroupButton>
        </div>)}
    </ShipmentScheduleListStyled>);
};
// eslint-disable-next-line react/display-name
var ShipmentScheduleGroup = function (_a) {
    var groupData = _a.groupData, shipDates = _a.shipDates, updateGroupShipmentDate = _a.updateGroupShipmentDate, updateGroupQuantity = _a.updateGroupQuantity, oneGroup = _a.oneGroup, removeGroup = _a.removeGroup, itemTotals = _a.itemTotals, removeShipmentIcon = _a.removeShipmentIcon, _b = _a.onlyFutureShipDateSelection, onlyFutureShipDateSelection = _b === void 0 ? false : _b;
    var _c = useState(dayjs(groupData.shipDate)), shipDate = _c[0], setShipDate = _c[1];
    var greaterOrEqualDate = moment(new Date()).add(1, 'd').format('MM/DD/YYYY');
    var emptyGroupWarning = !groupData.lines.some(function (item) {
        return item.quantity > 0;
    });
    var sameDateWarning = moment(shipDate === null || shipDate === void 0 ? void 0 : shipDate.toString()).isValid() &&
        shipDates.filter(function (date) {
            if (moment(groupData.shipDate).format('MM/DD/YYYY') === moment(date).format('MM/DD/YYYY'))
                return true;
        }).length > 1;
    var lesserDateWarning = !moment(shipDate === null || shipDate === void 0 ? void 0 : shipDate.toString()).isValid() ||
        moment(shipDate === null || shipDate === void 0 ? void 0 : shipDate.toString()).set({ second: 0, minute: 0, hour: 0 }) <
            moment(new Date()).set({ second: 0, minute: 0, hour: 0 });
    var shipDateInputProps = {
        value: shipDate,
        name: 'shipment-date',
        onChange: function (e) {
            e && setShipDate(e);
            e && updateGroupShipmentDate(groupData.id, moment(e.toString()).format('YYYY-MM-DD'));
        },
    };
    if (onlyFutureShipDateSelection) {
        shipDateInputProps.disablePast = true;
        shipDateInputProps.minDate = dayjs(moment(new Date()).add(1, 'days').format('MM/DD/YYYY'));
        shipDateInputProps.disableHighlightToday = true;
    }
    return (<ShipmentScheduleGroupStyle data-testid="shipment-group" id={groupData.id} style={emptyGroupWarning ? { borderColor: '#e9322d' } : {}}>
      <div style={{ color: '#a94442', paddingLeft: '10px' }}>
        {emptyGroupWarning && <p>Please provide a quantity to at least one item in this group.</p>}
        {sameDateWarning && <p>Another shipment group has the same date</p>}
        {lesserDateWarning && <p>The date must be greater than or equal to {greaterOrEqualDate}</p>}
      </div>
      <ShipmentHeaderStyled>
        <div style={{ width: '33%', height: '72px', marginRight: 'auto' }}>
          <InputDate {...shipDateInputProps}/>
        </div>
        {!oneGroup ? (<div style={{ width: '33.33%', display: 'flex' }}>
            <p>Quantity</p>
            <RemoveButtonContainer data-testid="remove-group-btn" onClick={function (e) {
                e.preventDefault();
                e.stopPropagation();
                removeGroup(groupData.id);
            }}>
              {removeShipmentIcon || (<RemoveGroupButton>
                  <RemoveGroupIcon />
                </RemoveGroupButton>)}
            </RemoveButtonContainer>
          </div>) : (<p style={{ width: '33.33%' }}>Quantity</p>)}
      </ShipmentHeaderStyled>
      <ShipmentScheduleItemListStyled>
        {groupData.lines.map(function (listItem) {
            var itemTotalImbalance = 0;
            var itemModified = false;
            var itemTotalData = itemTotals.find(function (item) { return item.partNumber === listItem.partNumber; });
            itemTotalImbalance = itemTotalData ? itemTotalData.quantity - itemTotalData.total : 0;
            itemModified = itemTotalData ? itemTotalData.modified : false;
            return (<ShipmentScheduleItem key={listItem.partNumber} groupID={groupData.id} item={listItem} itemTotalImbalance={itemTotalImbalance} itemModified={itemModified} updateGroupQuantity={updateGroupQuantity}></ShipmentScheduleItem>);
        })}
      </ShipmentScheduleItemListStyled>
    </ShipmentScheduleGroupStyle>);
};
var ShipmentScheduleItem = function (_a) {
    var item = _a.item, itemTotalImbalance = _a.itemTotalImbalance, itemModified = _a.itemModified, groupID = _a.groupID, updateGroupQuantity = _a.updateGroupQuantity;
    var _b = useState(item.quantity), quantity = _b[0], setQuantity = _b[1];
    return (<>
      {(itemModified || item.modified) && (<p style={{
                backgroundColor: '#e97b00',
                color: '#fff',
                textAlign: 'center',
                padding: '4px 0',
                margin: '10px',
                borderRadius: '4px',
            }}>
          Please update this item&apos;s shipment schedule to reflect your changes.
        </p>)}
      <ShipmentItemStyled data-testid="shipment-item">
        <p style={{ width: '16.66%' }}>{item.partNumber}</p>
        <p style={{ width: '50%' }}>{item.partName}</p>
        <div style={{
            width: '33.33%',
            display: 'flex',
            flexDirection: 'column',
        }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <input data-testid="qty-input" onChange={function (e) {
            var _a;
            var updatedQty = parseInt(((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value) && e.target.value);
            setQuantity(updatedQty);
            if (!isNaN(parseInt(e.target.value))) {
                updateGroupQuantity(groupID, item.partNumber, updatedQty);
            }
        }} value={quantity} type="number" min="0" max={item.total} style={{ width: '50%' }} className={itemTotalImbalance !== 0
            ? 'shipment-item-quantity shipment-item-quantity-warning'
            : 'shipment-item-quantity'}/>
            <p style={{ width: '48%', paddingLeft: '2%', margin: '0' }}>of {item.total}</p>
          </div>
          <ShipmentItemWarningStyled>
            {itemTotalImbalance !== 0 && (<p style={{ margin: '0', color: '#a94442' }}>
                {Math.abs(itemTotalImbalance)} {itemTotalImbalance > 0 ? ' over ' : ' under '} total
              </p>)}
          </ShipmentItemWarningStyled>
        </div>
      </ShipmentItemStyled>
    </>);
};
var AddGroupButton = function (_a) {
    var buttonText = _a.buttonText, buttonIcon = _a.buttonIcon, buttonColor = _a.buttonColor;
    return (
    //colorVariant prop can be set to "primary" (default),"secondary","tertiary" for more colors
    <AddGroupButtonStyled colorVariant={buttonColor}>
      {buttonIcon}
      {buttonText}
    </AddGroupButtonStyled>);
};
